/*eslint-disable*/
import React, { useContext, useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { useLocation } from "react-router-dom";
import errorImage from "../../assets/images/createPassword/errorImage.svg";
import errorImageright from "../../assets/images/createPassword/errorImageright.svg";
import errorImagewrong from "../../assets/images/createPassword/errorImagewrong.svg";
import hide from "../../assets/images/createPassword/hide.svg";
import show from "../../assets/images/createPassword/show.svg";
import darkShow from "../../assets/images/createPassword/darkShow.svg";
import darkHide from "../../assets/images/createPassword/darkHide.svg";
import "./password.scss";
import Button from "components/Button/index";
import useTheme from "hooks/observer";
import { signupContext } from "context/SignupContext";
import { useToast } from "components/Toaster/index";
import { addUserByEmail, addOrgByEmail, addUserByToken, ManageUser } from "@induz/sdk";
function Password({
  reset,
  isReset,
  nextStep,
  id,
  setUserData,
  email,
  question,
  answer,
  setMailData = () => { },
  setCanGoNext
}) {
  const showToast = useToast();
  const { formData, setFormData, isTypeSelect, setQrData, setOrgnization, setUser, selectedPlanData } =
    useContext(signupContext);
  // const navigate = useNavigate();
  // const location = useLocation();
  const [password, setPassword] = useState(formData.password || "");
  const [confirmPassword, setConfirmPassword] = useState(formData.confirmPassword || "");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);
  const [isValid, setIsValid] = useState(false);
  const [matchError, setMatchError] = useState(false);

  useEffect(() => {
    if (setCanGoNext) setCanGoNext(isValid);
  }, [isValid, setCanGoNext]);

  useEffect(() => {
    if (password) {
      checkPasswordRequirements(password);
      setMatchError(password && confirmPassword && password !== confirmPassword);
      setIsValid(
        password.length >= 12 &&
        /[a-z]/.test(password) &&
        /[A-Z]/.test(password) &&
        /\d/.test(password) &&
        /[#.?!@$%^&*-]/.test(password) &&
        password === confirmPassword
      );
    }
  }, []);

  const [isFocused, setIsFocused] = useState(false);
  const theme = useTheme();
  const hideImage = theme === "light" ? hide : darkShow;
  const showImage = theme === "light" ? show : darkHide;

  function hexStringToBytes(hexString) {
    if (hexString.length % 2 !== 0) {
      throw new Error("Invalid hex string length");
    }

    const bytes = new Uint8Array(hexString.length / 2);
    for (let i = 0; i < hexString.length; i += 2) {
      bytes[i / 2] = parseInt(hexString.substr(i, 2), 16);
    }

    return bytes;
  }
  const handleKeyDown = (e) => {
    if (e.key == "Enter") {
      handleSubmit(e);
    }

  };

  const handlePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };
  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    checkPasswordRequirements(value);

    setMatchError(value && confirmPassword && value !== confirmPassword);

    const isCurrentValid = 
      value.length >= 12 &&
      /[a-z]/.test(value) &&
      /[A-Z]/.test(value) &&
      /\d/.test(value) &&
      /[#.?!@$%^&*-]/.test(value) &&
      value === confirmPassword;

    setIsValid(isCurrentValid);
    setFormData((pre) => {
      return { ...pre, password: value };
    });
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);

    if (!password || value !== password) {
      setMatchError(true);
    } else {
      setMatchError(false);
    }

    const isCurrentValid = 
      password.length >= 12 &&
      /[a-z]/.test(password) &&
      /[A-Z]/.test(password) &&
      /\d/.test(password) &&
      /[#.?!@$%^&*-]/.test(password) &&
      value === password;

    setIsValid(isCurrentValid);
    setFormData((pre) => {
      return { ...pre, confirmPassword: value };
    });
  };

  const handleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };
  const checkPasswordRequirements = (value) => {
    const lengthValid = value.length >= 12;
    const lowercaseValid = /[a-z]/.test(value);
    const uppercaseValid = /[A-Z]/.test(value);
    const numberValid = /\d/.test(value);
    const specialCharValid = /[#.?!@$%^&*-]/.test(value);
    setIsValid(
      lengthValid &&
      lowercaseValid &&
      uppercaseValid &&
      numberValid &&
      specialCharValid
    );
  };
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      password !== "" &&
      confirmPassword !== "" &&
      password.length >= 12 &&
      confirmPassword.length >= 12 &&
      password === confirmPassword &&
      isValid
    ) {
      setMailData((pre) => {
        return { ...pre, password: password };
      });

      if (!isReset) {
        if (isTypeSelect === "individual") {
          if (!id) {
            try {
              const User = await addUserByEmail(
                formData.email,
                formData.password,
                selectedPlanData?.planId
              );
              console.log("plan selected",selectedPlanData);
              const totpKey = User.totpUri;
              setUser(User);
              await setQrData(totpKey);
              // await setFormData({});
              // navigate("/authentication");
              nextStep();
            } catch (error) {

              showToast(error.message, "error");
            }
          } else {
            try {

              const user = await addUserByToken(
                "",
                email,
                password,
                id
              );
              const totpKey = user.getTotpUri();
              setUser(user);
              await setQrData(totpKey);
              nextStep();
            } catch (error) {

              showToast(error.message, "error");
            }
          }
        } else {
          try {
            const org = await addOrgByEmail(
              formData.name,
              formData.email,
              formData.password,
              selectedPlanData?.planId
            );
            console.log("planId",selectedPlanData);
            setOrgnization(org);
            setUser(org);
            const totpKey = await org.getTotpUri();
            await setQrData(totpKey);
            nextStep();
          } catch (error) {

            showToast(error.message, "error");
          }
        }
      } else {
        try {

          if (!id) {
            showToast("Invalid link. Please check your email.", "error");
            return;
          }
          // console.log("id is ", answer);
          await ManageUser.changePasswordWithToken(
            email,
            hexStringToBytes(id),
            formData.password,
            question,
            answer
          );

          showToast("Password changed successfully", "success");
          const totpKey = await ManageUser.resetTotp();

          await setQrData(totpKey);

          nextStep();
        } catch (error) {
          showToast(error.message, "error");
        }
      }
    }
  };

  const getErrorStyle = (isValid) => ({
    color: !isValid && !isFocused ? "#99939F" : isValid ? "#339A33" : "#DC1818"
  });

  const handleCopyPaste = (e) => {
    e.preventDefault();
  };


  return (
    <>
      <section className="Password">
        <div className="container PasswordContainer">
          <div className="PasswordMain">
            <div className="PasswordContext">
              {reset ? (
                <h1 className="PasswordContextTitle">Reset Password</h1>
              ) : (
                <h1 className="PasswordContextTitle">Create Password</h1>
              )}
              {/* <p className="PasswordContextText">
                {reset
                  ? "Create a new password for your account to regain access. Ensure it is strong and secure."
                  : "Create a strong password for your account to ensure security."}
              </p> */}
            </div>
            <div className="PasswordWrapper">
              <div className="PasswordValid">
                <div className="password">
                  <div className="passwordField">
                    <p className="title">Password</p>
                    <div className="passwordVisible">
                      <input
                        type={isPasswordVisible ? "text" : "password"}
                        onChange={handlePasswordChange}
                        onKeyDown={handleKeyDown}
                        onFocus={() => setIsFocused(true)}
                        autoFocus
                        value={password}
                        placeholder="Enter the password"
                        required
                        onCopy={handleCopyPaste}
                        onPaste={handleCopyPaste}
                      />
                      <div
                        className="show-password"
                        type="button"
                        role="switch"
                        style={{ cursor: "pointer" }}
                        aria-label={
                          isPasswordVisible ? "Hide password" : "Show password"
                        }
                        aria-checked={isPasswordVisible ? "true" : "false"}
                        onClick={handlePasswordVisibility}
                      >
                        <img
                          src={isPasswordVisible ? showImage : hideImage}
                          alt="Toggle visibility"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="passwordErrors">
                    <div className="error">
                      <img
                        src={
                          !isValid && !isFocused
                            ? errorImage
                            : /[a-z]/.test(password)
                              ? errorImageright
                              : errorImagewrong
                        }
                        alt="error"
                      />
                      <p style={getErrorStyle(/[a-z]/.test(password))}>
                        Lowercase character
                      </p>
                    </div>
                    <div className="error">
                      <img
                        src={
                          !isValid && !isFocused
                            ? errorImage
                            : /[#.?!@$%^&*-]/.test(password)
                              ? errorImageright
                              : errorImagewrong
                        }
                        alt="error"
                      />
                      <p style={getErrorStyle(/[#.?!@$%^&*-]/.test(password))}>
                        Special character
                      </p>
                    </div>
                    <div className="error">
                      <img
                        src={
                          !isValid && !isFocused
                            ? errorImage
                            : /[A-Z]/.test(password)
                              ? errorImageright
                              : errorImagewrong
                        }
                        alt="error"
                      />
                      <p style={getErrorStyle(/[A-Z]/.test(password))}>
                        Uppercase character
                      </p>
                    </div>
                    <div className="error">
                      <img
                        src={
                          !isValid && !isFocused
                            ? errorImage
                            : password.length >= 12
                              ? errorImageright
                              : errorImagewrong
                        }
                        alt="error"
                      />
                      <p style={getErrorStyle(password.length >= 12)}>
                        12 Characters minimum
                      </p>
                    </div>
                    <div className="error">
                      <img
                        src={
                          !isValid && !isFocused
                            ? errorImage
                            : /\d/.test(password)
                              ? errorImageright
                              : errorImagewrong
                        }
                        alt="error"
                      />
                      <p style={getErrorStyle(/\d/.test(password))}>
                        Numeric character
                      </p>
                    </div>
                  </div>
                </div>
                <div className="confirmPassword">
                  <p className="title">Confirm Password</p>
                  <div
                    className="confirmPasswordFeild"
                    style={{ borderColor: matchError ? "#DC1818" : undefined }}
                  >
                    <input
                      type={isConfirmPasswordVisible ? "text" : "password"}
                      id="confirm-password"
                      value={confirmPassword}
                      onChange={handleConfirmPasswordChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Confirm password"
                      required
                      onCopy={handleCopyPaste}
                      onPaste={handleCopyPaste}
                    />
                    <div
                      className="show-password"
                      type="button"
                      role="switch"
                      style={{ cursor: "pointer" }}
                      aria-label={
                        isConfirmPasswordVisible
                          ? "Hide password"
                          : "Show password"
                      }
                      aria-checked={isConfirmPasswordVisible ? "true" : "false"}
                      onClick={handleConfirmPasswordVisibility}
                    >
                      <img
                        src={isConfirmPasswordVisible ? showImage : hideImage}
                        alt="Toggle visibility"
                      />
                    </div>
                  </div>
                  <p
                    className="errorMessage"
                    id="match"
                    style={{ visibility: matchError ? "visible" : "hidden", height: "18px", margin: 0, display: "block", lineHeight: "18px" }}
                  >
                    Passwords don&apos;t match
                  </p>
                </div>
              </div>
              <Button
                type="violet"
                title="Set Password"
                className={`PasswordSubmit ${password === confirmPassword ? "active" : "inactive"}`}
                disabled={
                  !(
                    password !== "" &&
                    confirmPassword !== "" &&
                    password.length >= 12 &&
                    confirmPassword.length >= 12 &&
                    password === confirmPassword &&
                    isValid
                  )
                }
                onClick={handleSubmit}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
export default Password;
